export default "__VITE_ASSET__b34366f2__"